import { css } from "@emotion/react";

export interface AvatarProps {
  name: string;
  size?: number;
}

const Avatar = ({ name, size = 43 }: AvatarProps) => {
  const innerSize = size - 6;
  const fontSize = Math.round(size * 0.37);

  return (
    <div
      css={css`
        align-items: center;
        border: 1px solid #046af3;
        border-radius: 50%;
        display: flex;
        height: ${size}px;
        justify-content: center;
        margin-right: 5px;
        width: ${size}px;
      `}
    >
      <div
        css={css`
          align-items: center;
          background-color: #d4e2f3;
          border-radius: 50%;
          color: #046af3;
          display: flex;
          font-size: ${fontSize}px;
          height: ${innerSize}px;
          justify-content: center;
          width: ${innerSize}px;
        `}
      >
        {name?.toUpperCase().charAt(0)}
      </div>
    </div>
  );
};

export default Avatar;
